export const productFeatureTemplates = {
	title: "Modelos de funcionalidad de producto",
	activeTab: "product-feature-templates",
	tooltip: "Cree modelos con campos personalizados para su producto",
	form: {
		isRequired: "Este campo es obligatorio",
		templateName: {
			label: "Nombre del modelo",
			placeholder: "Ingrese el nombre del modelo",
		},
		templateObservation: {
			label: "Observación",
			placeholder: "Ingrese alguna observación (opcional)",
		},
		templateFieldsContainer: {
			label: "Campos del modelo",
			add: "Agregar campo",
			field: "Campo {{number}}",
			type: {
				label: "Tipo del campo {{number}}",
				placeholder: "Seleccione el tipo del campo",
				text: "Texto",
				number: "Numeral",
				bool: "Verdadero/Falso",
				enum: "Opciones",
			},
			name: {
				label: "Nombre del campo {{number}}",
				placeholder: "Ingrese el nombre del campo {{number}}",
			},
			isRequired: "¿Campo {{number}} es obligatorio?",
			remove: "Eliminar campo",
			value: {
				label: "Opciones del campo {{number}}",
				placeholder: "Valor {{count}} del campo {{number}}",
			},
		},
		editModel: "Editar modelo",
		createModel: "Crear modelo",
		addProduct: {
			isRequired: "Este campo es obligatorio",
			fields: "Complete al menos un campo",
			wrongFields: {
				label: "Complete todos los datos",
				of: "del",
				from: "de los",
				field: "campo",
			},
		},
	},
	header: {
		add: "Agregar modelo",
	},
	modal: {
		edit: "Editar",
		add: "Agregar",
		title: "modelo de funcionalidad de producto",
	},
	templateList: {
		status: {
			title:
				"¿Realmente desea desactivar el modelo? Todas las funcionalidades que lo usan también serán desactivadas.",
		},
		actions: {
			title:
				"¿Realmente desea eliminar el modelo? Todas las funcionalidades que lo usan también serán desactivadas.",
			edit: "Editar modelo",
			remove: "Eliminar modelo",
		},
	},
};
